import React, { useEffect, useState } from 'react';
import { GoogleApiWrapper } from 'google-maps-react';
import { connect } from 'react-redux';
import { getLocation } from 'connected-react-router';
import {setLocation } from '../../store/actions/UserAction';

const MapContainerData = ({ google, setLocation }) => {

    const rejectCoordinates = () => {
        const latInLocal = localStorage.getItem('Latitude')
        const lngInLocal = localStorage.getItem('Longitude')
        const stateOfCountry = localStorage.getItem('stateOfCountry')
        if (latInLocal) {
            localStorage.removeItem('Latitude')
        }
        if (lngInLocal) {
            localStorage.removeItem('Longitude')
        }
        if (stateOfCountry) {
            localStorage.removeItem('stateOfCountry')
        }
        setLocation('')
    }

    const getAddress = results => {
        let region = ''
        let country = ''
        if (results[1]) {
            let index = 0;
            
            for (let j = 0; j < results.length; j++) {
                if (results[j].types[0] === 'street_address') {
                    index = j;
                    break;
                }
            }
            for (let i = 0; i < results[index].address_components.length; i++) {
                if (results[index].address_components[i].types[0] === "administrative_area_level_1") {
                    region = results[index].address_components[i];
                }
            }

            for (let j = 0; j < results.length; j++) {
                if (results[j].types[0] === 'country') {
                    index = j;
                    break;
                }
            }
            for (let i = 0; i < results[index].address_components.length; i++) {
                if (results[index].address_components[i].types[0] === "country") {
                    country = results[index].address_components[i];
                }
            }

            return {
                region: region.long_name,
                country: country.long_name
            }
        }
    }

    const successLocation = results => {
        const data = getAddress(results);
        let region = ''
        if (data) {
            if (data.country !== 'Mexico') {
                region = 'CDMX' 
            }
            if (data.region === 'Ciudad de México') {
                region = 'CDMX'
            } else {
                region = data.region
            }
            localStorage.setItem('stateOfCountry', region)
            setLocation(region)
        }
    }

    const successCoordinates = position => {
        const ReverseGeocoder = new google.maps.Geocoder();
        const geolocalizeInRefresh = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
        );

        const latInLocal = localStorage.getItem('Latitude')
        const lngInLocal = localStorage.getItem('Longitude')
        const stateOfCountry = localStorage.getItem('stateOfCountry')

        if (
            !latInLocal ||
            !lngInLocal ||
            !stateOfCountry ||
            Number(latInLocal) !== geolocalizeInRefresh.lat() ||
            Number(lngInLocal) !== geolocalizeInRefresh.lng()
        ) {
            ReverseGeocoder.geocode(
                {'latLng': geolocalizeInRefresh},
                successLocation
            )
            localStorage.setItem('Latitude', geolocalizeInRefresh.lat())
            localStorage.setItem('Longitude', geolocalizeInRefresh.lng())
        }
    }

    const [ didRender, setDidRender ] = useState(false)

    useEffect(() => {
        const stateOfCountry = localStorage.getItem('stateOfCountry')
        if (!didRender) {
            setLocation(stateOfCountry ? stateOfCountry : '')
            setDidRender(true)
        }
        navigator.geolocation.getCurrentPosition(
            successCoordinates,
            rejectCoordinates
        );
        // stateOfCountry &&
    }, [didRender, setLocation])
      
    return <div />
}

const mapDispatchToProps = dispatch => ({
    setLocation: location => dispatch(setLocation(location)), 
})

export default connect(null, mapDispatchToProps)(GoogleApiWrapper(
    (props) => ({
      apiKey: process.env.REACT_APP_FIREBASE_KEY,
    }
))(MapContainerData));
